import { API_ROUTES, request } from './instance';
import { CompositeAuditsAPI } from '@shared';

// swagger https://qa-auditor.proctorfree.com/swagger-ui/#/auditor-controller

export const getIncompleteAudits = (page: number) => {
  return request<NeedsReviewTableAPI>({
    url: API_ROUTES.apiReactIncompleteAudits(page),
    method: 'GET',
  });
};

export const getNeedsReview = (page: number) => {
  return request<NeedsReviewTableAPI>({
    url: API_ROUTES.apiReactNeedsReview(page),
    method: 'GET',
  });
};

export const getAuditQueue = (page: number) => {
  return request<AuditQueueTablesAPI>({
    url: API_ROUTES.apiReactAuditQueue(page),
    method: 'GET',
  });
};

export const getTargetReport = (examSessionUuid: string) => {
  return request<TargetReportAPI>({
    url: API_ROUTES.apiReactTargetReport(examSessionUuid),
    method: 'GET',
  });
};

export type NeedsReviewTableAPI = {
  totalResults: number;
  compositeAudits: CompositeAuditsAPI;
};
export type AuditInProgressAPI = {
  auditStartTime: number[];
  auditUuid: string;
  examSessionEndTime: number[];
  examSessionStartTime: number[];
};
export type AuditsInQueueAPI = {
  examEndTime: number[];
  examStartTime: number[];
  examDuration: string;
  userFirstName: string;
  userLastName: string;
  partnerName: string;
  specialPartner: boolean;
  courseName: string;
  examName: string;
  examSessionHandle: string;
};
export type AuditQueueTablesAPI = {
  auditExamSessionList: Array<AuditInProgressAPI>;
  examSessions: Array<AuditsInQueueAPI>;
  totalResults: number;
};
export type ReportTypeAPI = {
  configuration: string;
  mode: string;
  name: string;
  regions: Array<{
    center: number;
    end: number;
    length: number;
    start: number;
    suspectType: string;
    type: string;
  }>;
  targetDuration: string;
};
type TargetReportAPI = {
  examSessionUuid: string;
  streamHandle: string;
  streamUiBaseUrl: string;
  partner: {
    name: string;
    uuid: string;
  };
  error: string;
  partnerTargetProfile: string;
  reports: ReportTypeAPI[];
};
